import * as React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import Toolbar from '@mui/material/Toolbar';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import MenuIcon from '@mui/icons-material/Menu';
import LogoutIcon from '@mui/icons-material/Logout';
import { useNavigate } from 'react-router-dom';
import { auth } from '../Pages/Services/Firebase/firebaseConfigOuvidoria';

const NAVY = '#011838';
const GOLD = '#FDC500';

const Header = ({ onDrawerToggle }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const navigate = useNavigate();

    const handleLogout = async () => {
        try {
            await auth.signOut();
            navigate('/login');
        } catch (error) {
            console.error('Erro ao deslogar:', error);
        }
        setAnchorEl(null);
    };

    return (
        <AppBar
            position="sticky"
            elevation={0}
            sx={{
                bgcolor: NAVY,
                borderBottom: `3px solid ${GOLD}`,
            }}
        >
            <Toolbar sx={{ minHeight: '56px !important', px: { xs: 1.5, sm: 3 } }}>
                <Grid container alignItems="center" spacing={1}>
                    <Grid item sx={{ display: { sm: 'none', xs: 'block' } }}>
                        <IconButton color="inherit" onClick={onDrawerToggle} edge="start" size="small">
                            <MenuIcon />
                        </IconButton>
                    </Grid>
                    <Grid item>
                        <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1.5 }}>
                            <Typography sx={{
                                fontFamily: '"Bank Gothic", "Helvetica Neue", Helvetica, Arial, sans-serif',
                                fontSize: 17,
                                fontWeight: 'bold',
                                letterSpacing: 4,
                                color: GOLD,
                                textTransform: 'uppercase',
                                lineHeight: 1,
                            }}>
                                METRUM
                            </Typography>
                            <Typography sx={{
                                color: 'rgba(255,255,255,0.45)',
                                fontSize: 11,
                                letterSpacing: 2,
                                textTransform: 'uppercase',
                                display: { xs: 'none', sm: 'block' },
                            }}>
                                Canal de Ouvidoria
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs />
                    <Grid item>
                        <IconButton
                            size="small"
                            onClick={(e) => setAnchorEl(e.currentTarget)}
                            sx={{ p: 0.5 }}
                        >
                            <Avatar sx={{ width: 32, height: 32, bgcolor: '#003E87', fontSize: 14, fontWeight: 700 }}>
                                A
                            </Avatar>
                        </IconButton>
                        <Menu
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={() => setAnchorEl(null)}
                            PaperProps={{ elevation: 3, sx: { mt: 1, minWidth: 160, borderRadius: 2 } }}
                        >
                            <MenuItem onClick={handleLogout} sx={{ gap: 1.5, fontSize: 14, py: 1.2 }}>
                                <LogoutIcon fontSize="small" sx={{ color: '#666' }} />
                                Sair da conta
                            </MenuItem>
                        </Menu>
                    </Grid>
                </Grid>
            </Toolbar>
        </AppBar>
    );
};

Header.propTypes = {
    onDrawerToggle: PropTypes.func.isRequired,
};

export default Header;
